package com.shadowings.gero.data.repository

import gero.composeapp.generated.resources.A1
import gero.composeapp.generated.resources.A10
import gero.composeapp.generated.resources.A11
import gero.composeapp.generated.resources.A12
import gero.composeapp.generated.resources.A13
import gero.composeapp.generated.resources.A14
import gero.composeapp.generated.resources.A14A
import gero.composeapp.generated.resources.A15
import gero.composeapp.generated.resources.A16
import gero.composeapp.generated.resources.A17
import gero.composeapp.generated.resources.A17A
import gero.composeapp.generated.resources.A18
import gero.composeapp.generated.resources.A19
import gero.composeapp.generated.resources.A2
import gero.composeapp.generated.resources.A20
import gero.composeapp.generated.resources.A21
import gero.composeapp.generated.resources.A22
import gero.composeapp.generated.resources.A23
import gero.composeapp.generated.resources.A24
import gero.composeapp.generated.resources.A25
import gero.composeapp.generated.resources.A26
import gero.composeapp.generated.resources.A27
import gero.composeapp.generated.resources.A28
import gero.composeapp.generated.resources.A29
import gero.composeapp.generated.resources.A3
import gero.composeapp.generated.resources.A30
import gero.composeapp.generated.resources.A31
import gero.composeapp.generated.resources.A32
import gero.composeapp.generated.resources.A32A
import gero.composeapp.generated.resources.A33
import gero.composeapp.generated.resources.A34
import gero.composeapp.generated.resources.A35
import gero.composeapp.generated.resources.A36
import gero.composeapp.generated.resources.A37
import gero.composeapp.generated.resources.A38
import gero.composeapp.generated.resources.A39
import gero.composeapp.generated.resources.A4
import gero.composeapp.generated.resources.A40
import gero.composeapp.generated.resources.A40A
import gero.composeapp.generated.resources.A41
import gero.composeapp.generated.resources.A42
import gero.composeapp.generated.resources.A42A
import gero.composeapp.generated.resources.A43
import gero.composeapp.generated.resources.A43A
import gero.composeapp.generated.resources.A44
import gero.composeapp.generated.resources.A45
import gero.composeapp.generated.resources.A45A
import gero.composeapp.generated.resources.A46
import gero.composeapp.generated.resources.A47
import gero.composeapp.generated.resources.A48
import gero.composeapp.generated.resources.A49
import gero.composeapp.generated.resources.A5
import gero.composeapp.generated.resources.A50
import gero.composeapp.generated.resources.A51
import gero.composeapp.generated.resources.A52
import gero.composeapp.generated.resources.A53
import gero.composeapp.generated.resources.A54
import gero.composeapp.generated.resources.A55
import gero.composeapp.generated.resources.A56
import gero.composeapp.generated.resources.A57
import gero.composeapp.generated.resources.A58
import gero.composeapp.generated.resources.A59
import gero.composeapp.generated.resources.A5A
import gero.composeapp.generated.resources.A6
import gero.composeapp.generated.resources.A60
import gero.composeapp.generated.resources.A61
import gero.composeapp.generated.resources.A62
import gero.composeapp.generated.resources.A63
import gero.composeapp.generated.resources.A64
import gero.composeapp.generated.resources.A65
import gero.composeapp.generated.resources.A66
import gero.composeapp.generated.resources.A67
import gero.composeapp.generated.resources.A68
import gero.composeapp.generated.resources.A69
import gero.composeapp.generated.resources.A6A
import gero.composeapp.generated.resources.A6B
import gero.composeapp.generated.resources.A7
import gero.composeapp.generated.resources.A70
import gero.composeapp.generated.resources.A8
import gero.composeapp.generated.resources.A9
import gero.composeapp.generated.resources.Aa1
import gero.composeapp.generated.resources.Aa10
import gero.composeapp.generated.resources.Aa11
import gero.composeapp.generated.resources.Aa12
import gero.composeapp.generated.resources.Aa13
import gero.composeapp.generated.resources.Aa14
import gero.composeapp.generated.resources.Aa15
import gero.composeapp.generated.resources.Aa16
import gero.composeapp.generated.resources.Aa17
import gero.composeapp.generated.resources.Aa18
import gero.composeapp.generated.resources.Aa19
import gero.composeapp.generated.resources.Aa2
import gero.composeapp.generated.resources.Aa20
import gero.composeapp.generated.resources.Aa21
import gero.composeapp.generated.resources.Aa22
import gero.composeapp.generated.resources.Aa23
import gero.composeapp.generated.resources.Aa24
import gero.composeapp.generated.resources.Aa25
import gero.composeapp.generated.resources.Aa26
import gero.composeapp.generated.resources.Aa27
import gero.composeapp.generated.resources.Aa28
import gero.composeapp.generated.resources.Aa29
import gero.composeapp.generated.resources.Aa3
import gero.composeapp.generated.resources.Aa30
import gero.composeapp.generated.resources.Aa31
import gero.composeapp.generated.resources.Aa32
import gero.composeapp.generated.resources.Aa4
import gero.composeapp.generated.resources.Aa5
import gero.composeapp.generated.resources.Aa6
import gero.composeapp.generated.resources.Aa7
import gero.composeapp.generated.resources.Aa7A
import gero.composeapp.generated.resources.Aa7B
import gero.composeapp.generated.resources.Aa8
import gero.composeapp.generated.resources.Aa9
import gero.composeapp.generated.resources.B1
import gero.composeapp.generated.resources.B2
import gero.composeapp.generated.resources.B3
import gero.composeapp.generated.resources.B4
import gero.composeapp.generated.resources.B5
import gero.composeapp.generated.resources.B5A
import gero.composeapp.generated.resources.B6
import gero.composeapp.generated.resources.B7
import gero.composeapp.generated.resources.B8
import gero.composeapp.generated.resources.B9
import gero.composeapp.generated.resources.C1
import gero.composeapp.generated.resources.C10
import gero.composeapp.generated.resources.C10A
import gero.composeapp.generated.resources.C11
import gero.composeapp.generated.resources.C12
import gero.composeapp.generated.resources.C13
import gero.composeapp.generated.resources.C14
import gero.composeapp.generated.resources.C15
import gero.composeapp.generated.resources.C16
import gero.composeapp.generated.resources.C17
import gero.composeapp.generated.resources.C18
import gero.composeapp.generated.resources.C19
import gero.composeapp.generated.resources.C2
import gero.composeapp.generated.resources.C20
import gero.composeapp.generated.resources.C21
import gero.composeapp.generated.resources.C22
import gero.composeapp.generated.resources.C23
import gero.composeapp.generated.resources.C24
import gero.composeapp.generated.resources.C2A
import gero.composeapp.generated.resources.C2B
import gero.composeapp.generated.resources.C2C
import gero.composeapp.generated.resources.C3
import gero.composeapp.generated.resources.C4
import gero.composeapp.generated.resources.C5
import gero.composeapp.generated.resources.C6
import gero.composeapp.generated.resources.C7
import gero.composeapp.generated.resources.C8
import gero.composeapp.generated.resources.C9
import gero.composeapp.generated.resources.D1
import gero.composeapp.generated.resources.D10
import gero.composeapp.generated.resources.D11
import gero.composeapp.generated.resources.D12
import gero.composeapp.generated.resources.D13
import gero.composeapp.generated.resources.D14
import gero.composeapp.generated.resources.D15
import gero.composeapp.generated.resources.D16
import gero.composeapp.generated.resources.D17
import gero.composeapp.generated.resources.D18
import gero.composeapp.generated.resources.D19
import gero.composeapp.generated.resources.D2
import gero.composeapp.generated.resources.D20
import gero.composeapp.generated.resources.D21
import gero.composeapp.generated.resources.D22
import gero.composeapp.generated.resources.D23
import gero.composeapp.generated.resources.D24
import gero.composeapp.generated.resources.D25
import gero.composeapp.generated.resources.D26
import gero.composeapp.generated.resources.D27
import gero.composeapp.generated.resources.D27A
import gero.composeapp.generated.resources.D28
import gero.composeapp.generated.resources.D29
import gero.composeapp.generated.resources.D3
import gero.composeapp.generated.resources.D30
import gero.composeapp.generated.resources.D31
import gero.composeapp.generated.resources.D31A
import gero.composeapp.generated.resources.D32
import gero.composeapp.generated.resources.D33
import gero.composeapp.generated.resources.D34
import gero.composeapp.generated.resources.D34A
import gero.composeapp.generated.resources.D35
import gero.composeapp.generated.resources.D36
import gero.composeapp.generated.resources.D37
import gero.composeapp.generated.resources.D38
import gero.composeapp.generated.resources.D39
import gero.composeapp.generated.resources.D4
import gero.composeapp.generated.resources.D40
import gero.composeapp.generated.resources.D41
import gero.composeapp.generated.resources.D42
import gero.composeapp.generated.resources.D43
import gero.composeapp.generated.resources.D44
import gero.composeapp.generated.resources.D45
import gero.composeapp.generated.resources.D46
import gero.composeapp.generated.resources.D46A
import gero.composeapp.generated.resources.D47
import gero.composeapp.generated.resources.D48
import gero.composeapp.generated.resources.D48A
import gero.composeapp.generated.resources.D49
import gero.composeapp.generated.resources.D5
import gero.composeapp.generated.resources.D50
import gero.composeapp.generated.resources.D50A
import gero.composeapp.generated.resources.D50B
import gero.composeapp.generated.resources.D50C
import gero.composeapp.generated.resources.D50D
import gero.composeapp.generated.resources.D50E
import gero.composeapp.generated.resources.D50F
import gero.composeapp.generated.resources.D50G
import gero.composeapp.generated.resources.D50H
import gero.composeapp.generated.resources.D50I
import gero.composeapp.generated.resources.D51
import gero.composeapp.generated.resources.D52
import gero.composeapp.generated.resources.D52A
import gero.composeapp.generated.resources.D53
import gero.composeapp.generated.resources.D54
import gero.composeapp.generated.resources.D54A
import gero.composeapp.generated.resources.D55
import gero.composeapp.generated.resources.D56
import gero.composeapp.generated.resources.D57
import gero.composeapp.generated.resources.D58
import gero.composeapp.generated.resources.D59
import gero.composeapp.generated.resources.D6
import gero.composeapp.generated.resources.D60
import gero.composeapp.generated.resources.D61
import gero.composeapp.generated.resources.D62
import gero.composeapp.generated.resources.D63
import gero.composeapp.generated.resources.D64
import gero.composeapp.generated.resources.D65
import gero.composeapp.generated.resources.D66
import gero.composeapp.generated.resources.D67
import gero.composeapp.generated.resources.D67A
import gero.composeapp.generated.resources.D67B
import gero.composeapp.generated.resources.D67C
import gero.composeapp.generated.resources.D67D
import gero.composeapp.generated.resources.D67E
import gero.composeapp.generated.resources.D67F
import gero.composeapp.generated.resources.D67G
import gero.composeapp.generated.resources.D67H
import gero.composeapp.generated.resources.D7
import gero.composeapp.generated.resources.D8
import gero.composeapp.generated.resources.D8A
import gero.composeapp.generated.resources.D9
import gero.composeapp.generated.resources.E1
import gero.composeapp.generated.resources.E10
import gero.composeapp.generated.resources.E11
import gero.composeapp.generated.resources.E12
import gero.composeapp.generated.resources.E13
import gero.composeapp.generated.resources.E14
import gero.composeapp.generated.resources.E15
import gero.composeapp.generated.resources.E16
import gero.composeapp.generated.resources.E16A
import gero.composeapp.generated.resources.E17
import gero.composeapp.generated.resources.E17A
import gero.composeapp.generated.resources.E18
import gero.composeapp.generated.resources.E19
import gero.composeapp.generated.resources.E2
import gero.composeapp.generated.resources.E20
import gero.composeapp.generated.resources.E20A
import gero.composeapp.generated.resources.E21
import gero.composeapp.generated.resources.E22
import gero.composeapp.generated.resources.E23
import gero.composeapp.generated.resources.E24
import gero.composeapp.generated.resources.E25
import gero.composeapp.generated.resources.E26
import gero.composeapp.generated.resources.E27
import gero.composeapp.generated.resources.E28
import gero.composeapp.generated.resources.E28A
import gero.composeapp.generated.resources.E29
import gero.composeapp.generated.resources.E3
import gero.composeapp.generated.resources.E30
import gero.composeapp.generated.resources.E31
import gero.composeapp.generated.resources.E32
import gero.composeapp.generated.resources.E33
import gero.composeapp.generated.resources.E34
import gero.composeapp.generated.resources.E34A
import gero.composeapp.generated.resources.E36
import gero.composeapp.generated.resources.E37
import gero.composeapp.generated.resources.E38
import gero.composeapp.generated.resources.E4
import gero.composeapp.generated.resources.E5
import gero.composeapp.generated.resources.E6
import gero.composeapp.generated.resources.E7
import gero.composeapp.generated.resources.E8
import gero.composeapp.generated.resources.E8A
import gero.composeapp.generated.resources.E9
import gero.composeapp.generated.resources.E9A
import gero.composeapp.generated.resources.F1
import gero.composeapp.generated.resources.F10
import gero.composeapp.generated.resources.F11
import gero.composeapp.generated.resources.F12
import gero.composeapp.generated.resources.F13
import gero.composeapp.generated.resources.F13A
import gero.composeapp.generated.resources.F14
import gero.composeapp.generated.resources.F15
import gero.composeapp.generated.resources.F16
import gero.composeapp.generated.resources.F17
import gero.composeapp.generated.resources.F18
import gero.composeapp.generated.resources.F19
import gero.composeapp.generated.resources.F1A
import gero.composeapp.generated.resources.F2
import gero.composeapp.generated.resources.F20
import gero.composeapp.generated.resources.F21
import gero.composeapp.generated.resources.F21A
import gero.composeapp.generated.resources.F22
import gero.composeapp.generated.resources.F23
import gero.composeapp.generated.resources.F24
import gero.composeapp.generated.resources.F25
import gero.composeapp.generated.resources.F26
import gero.composeapp.generated.resources.F27
import gero.composeapp.generated.resources.F28
import gero.composeapp.generated.resources.F29
import gero.composeapp.generated.resources.F3
import gero.composeapp.generated.resources.F30
import gero.composeapp.generated.resources.F31
import gero.composeapp.generated.resources.F31A
import gero.composeapp.generated.resources.F32
import gero.composeapp.generated.resources.F33
import gero.composeapp.generated.resources.F34
import gero.composeapp.generated.resources.F35
import gero.composeapp.generated.resources.F36
import gero.composeapp.generated.resources.F37
import gero.composeapp.generated.resources.F37A
import gero.composeapp.generated.resources.F38
import gero.composeapp.generated.resources.F38A
import gero.composeapp.generated.resources.F39
import gero.composeapp.generated.resources.F4
import gero.composeapp.generated.resources.F40
import gero.composeapp.generated.resources.F41
import gero.composeapp.generated.resources.F42
import gero.composeapp.generated.resources.F43
import gero.composeapp.generated.resources.F44
import gero.composeapp.generated.resources.F45
import gero.composeapp.generated.resources.F45A
import gero.composeapp.generated.resources.F46
import gero.composeapp.generated.resources.F46A
import gero.composeapp.generated.resources.F47
import gero.composeapp.generated.resources.F47A
import gero.composeapp.generated.resources.F48
import gero.composeapp.generated.resources.F49
import gero.composeapp.generated.resources.F5
import gero.composeapp.generated.resources.F50
import gero.composeapp.generated.resources.F51
import gero.composeapp.generated.resources.F51A
import gero.composeapp.generated.resources.F51B
import gero.composeapp.generated.resources.F51C
import gero.composeapp.generated.resources.F52
import gero.composeapp.generated.resources.F53
import gero.composeapp.generated.resources.F6
import gero.composeapp.generated.resources.F7
import gero.composeapp.generated.resources.F8
import gero.composeapp.generated.resources.F9
import gero.composeapp.generated.resources.G1
import gero.composeapp.generated.resources.G10
import gero.composeapp.generated.resources.G11
import gero.composeapp.generated.resources.G11A
import gero.composeapp.generated.resources.G12
import gero.composeapp.generated.resources.G13
import gero.composeapp.generated.resources.G14
import gero.composeapp.generated.resources.G15
import gero.composeapp.generated.resources.G16
import gero.composeapp.generated.resources.G17
import gero.composeapp.generated.resources.G18
import gero.composeapp.generated.resources.G19
import gero.composeapp.generated.resources.G2
import gero.composeapp.generated.resources.G20
import gero.composeapp.generated.resources.G20A
import gero.composeapp.generated.resources.G21
import gero.composeapp.generated.resources.G22
import gero.composeapp.generated.resources.G23
import gero.composeapp.generated.resources.G24
import gero.composeapp.generated.resources.G25
import gero.composeapp.generated.resources.G26
import gero.composeapp.generated.resources.G26A
import gero.composeapp.generated.resources.G27
import gero.composeapp.generated.resources.G28
import gero.composeapp.generated.resources.G29
import gero.composeapp.generated.resources.G3
import gero.composeapp.generated.resources.G30
import gero.composeapp.generated.resources.G31
import gero.composeapp.generated.resources.G32
import gero.composeapp.generated.resources.G33
import gero.composeapp.generated.resources.G34
import gero.composeapp.generated.resources.G35
import gero.composeapp.generated.resources.G36
import gero.composeapp.generated.resources.G36A
import gero.composeapp.generated.resources.G37
import gero.composeapp.generated.resources.G37A
import gero.composeapp.generated.resources.G38
import gero.composeapp.generated.resources.G39
import gero.composeapp.generated.resources.G39X1
import gero.composeapp.generated.resources.G4
import gero.composeapp.generated.resources.G40
import gero.composeapp.generated.resources.G41
import gero.composeapp.generated.resources.G42
import gero.composeapp.generated.resources.G43
import gero.composeapp.generated.resources.G43A
import gero.composeapp.generated.resources.G43B
import gero.composeapp.generated.resources.G44
import gero.composeapp.generated.resources.G45
import gero.composeapp.generated.resources.G45A
import gero.composeapp.generated.resources.G46
import gero.composeapp.generated.resources.G47
import gero.composeapp.generated.resources.G48
import gero.composeapp.generated.resources.G49
import gero.composeapp.generated.resources.G5
import gero.composeapp.generated.resources.G50
import gero.composeapp.generated.resources.G51
import gero.composeapp.generated.resources.G52
import gero.composeapp.generated.resources.G53
import gero.composeapp.generated.resources.G54
import gero.composeapp.generated.resources.G6
import gero.composeapp.generated.resources.G6A
import gero.composeapp.generated.resources.G7
import gero.composeapp.generated.resources.G7A
import gero.composeapp.generated.resources.G7B
import gero.composeapp.generated.resources.G8
import gero.composeapp.generated.resources.G9
import gero.composeapp.generated.resources.H1
import gero.composeapp.generated.resources.H2
import gero.composeapp.generated.resources.H3
import gero.composeapp.generated.resources.H4
import gero.composeapp.generated.resources.H5
import gero.composeapp.generated.resources.H6
import gero.composeapp.generated.resources.H6A
import gero.composeapp.generated.resources.H7
import gero.composeapp.generated.resources.H8
import gero.composeapp.generated.resources.I1
import gero.composeapp.generated.resources.I10
import gero.composeapp.generated.resources.I10A
import gero.composeapp.generated.resources.I10X1
import gero.composeapp.generated.resources.I11
import gero.composeapp.generated.resources.I11A
import gero.composeapp.generated.resources.I12
import gero.composeapp.generated.resources.I13
import gero.composeapp.generated.resources.I14
import gero.composeapp.generated.resources.I15
import gero.composeapp.generated.resources.I2
import gero.composeapp.generated.resources.I3
import gero.composeapp.generated.resources.I4
import gero.composeapp.generated.resources.I5
import gero.composeapp.generated.resources.I5A
import gero.composeapp.generated.resources.I6
import gero.composeapp.generated.resources.I7
import gero.composeapp.generated.resources.I8
import gero.composeapp.generated.resources.I9
import gero.composeapp.generated.resources.I9A
import gero.composeapp.generated.resources.K1
import gero.composeapp.generated.resources.K2
import gero.composeapp.generated.resources.K3
import gero.composeapp.generated.resources.K4
import gero.composeapp.generated.resources.K5
import gero.composeapp.generated.resources.K6
import gero.composeapp.generated.resources.K7
import gero.composeapp.generated.resources.K8
import gero.composeapp.generated.resources.L1
import gero.composeapp.generated.resources.L2
import gero.composeapp.generated.resources.L2A
import gero.composeapp.generated.resources.L3
import gero.composeapp.generated.resources.L4
import gero.composeapp.generated.resources.L5
import gero.composeapp.generated.resources.L6
import gero.composeapp.generated.resources.L6A
import gero.composeapp.generated.resources.L7
import gero.composeapp.generated.resources.L8
import gero.composeapp.generated.resources.M1
import gero.composeapp.generated.resources.M10
import gero.composeapp.generated.resources.M10A
import gero.composeapp.generated.resources.M11
import gero.composeapp.generated.resources.M12
import gero.composeapp.generated.resources.M12A
import gero.composeapp.generated.resources.M12B
import gero.composeapp.generated.resources.M12C
import gero.composeapp.generated.resources.M12D
import gero.composeapp.generated.resources.M12E
import gero.composeapp.generated.resources.M12F
import gero.composeapp.generated.resources.M12G
import gero.composeapp.generated.resources.M12H
import gero.composeapp.generated.resources.M13
import gero.composeapp.generated.resources.M14
import gero.composeapp.generated.resources.M15
import gero.composeapp.generated.resources.M15A
import gero.composeapp.generated.resources.M16
import gero.composeapp.generated.resources.M16A
import gero.composeapp.generated.resources.M17
import gero.composeapp.generated.resources.M17A
import gero.composeapp.generated.resources.M18
import gero.composeapp.generated.resources.M19
import gero.composeapp.generated.resources.M1A
import gero.composeapp.generated.resources.M1B
import gero.composeapp.generated.resources.M2
import gero.composeapp.generated.resources.M20
import gero.composeapp.generated.resources.M21
import gero.composeapp.generated.resources.M22
import gero.composeapp.generated.resources.M22A
import gero.composeapp.generated.resources.M23
import gero.composeapp.generated.resources.M24
import gero.composeapp.generated.resources.M24A
import gero.composeapp.generated.resources.M25
import gero.composeapp.generated.resources.M26
import gero.composeapp.generated.resources.M27
import gero.composeapp.generated.resources.M28
import gero.composeapp.generated.resources.M28A
import gero.composeapp.generated.resources.M29
import gero.composeapp.generated.resources.M3
import gero.composeapp.generated.resources.M30
import gero.composeapp.generated.resources.M31
import gero.composeapp.generated.resources.M31A
import gero.composeapp.generated.resources.M32
import gero.composeapp.generated.resources.M33
import gero.composeapp.generated.resources.M33A
import gero.composeapp.generated.resources.M33B
import gero.composeapp.generated.resources.M34
import gero.composeapp.generated.resources.M35
import gero.composeapp.generated.resources.M36
import gero.composeapp.generated.resources.M37
import gero.composeapp.generated.resources.M38
import gero.composeapp.generated.resources.M39
import gero.composeapp.generated.resources.M3A
import gero.composeapp.generated.resources.M4
import gero.composeapp.generated.resources.M40
import gero.composeapp.generated.resources.M40A
import gero.composeapp.generated.resources.M41
import gero.composeapp.generated.resources.M42
import gero.composeapp.generated.resources.M43
import gero.composeapp.generated.resources.M44
import gero.composeapp.generated.resources.M5
import gero.composeapp.generated.resources.M6
import gero.composeapp.generated.resources.M7
import gero.composeapp.generated.resources.M8
import gero.composeapp.generated.resources.M9
import gero.composeapp.generated.resources.N1
import gero.composeapp.generated.resources.N10
import gero.composeapp.generated.resources.N11
import gero.composeapp.generated.resources.N12
import gero.composeapp.generated.resources.N13
import gero.composeapp.generated.resources.N14
import gero.composeapp.generated.resources.N15
import gero.composeapp.generated.resources.N16
import gero.composeapp.generated.resources.N17
import gero.composeapp.generated.resources.N18
import gero.composeapp.generated.resources.N18A
import gero.composeapp.generated.resources.N18B
import gero.composeapp.generated.resources.N19
import gero.composeapp.generated.resources.N2
import gero.composeapp.generated.resources.N20
import gero.composeapp.generated.resources.N21
import gero.composeapp.generated.resources.N22
import gero.composeapp.generated.resources.N23
import gero.composeapp.generated.resources.N24
import gero.composeapp.generated.resources.N25
import gero.composeapp.generated.resources.N25A
import gero.composeapp.generated.resources.N26
import gero.composeapp.generated.resources.N27
import gero.composeapp.generated.resources.N28
import gero.composeapp.generated.resources.N29
import gero.composeapp.generated.resources.N3
import gero.composeapp.generated.resources.N30
import gero.composeapp.generated.resources.N31
import gero.composeapp.generated.resources.N32
import gero.composeapp.generated.resources.N33
import gero.composeapp.generated.resources.N33A
import gero.composeapp.generated.resources.N34
import gero.composeapp.generated.resources.N34A
import gero.composeapp.generated.resources.N35
import gero.composeapp.generated.resources.N35A
import gero.composeapp.generated.resources.N36
import gero.composeapp.generated.resources.N37
import gero.composeapp.generated.resources.N37A
import gero.composeapp.generated.resources.N38
import gero.composeapp.generated.resources.N39
import gero.composeapp.generated.resources.N4
import gero.composeapp.generated.resources.N40
import gero.composeapp.generated.resources.N41
import gero.composeapp.generated.resources.N42
import gero.composeapp.generated.resources.N5
import gero.composeapp.generated.resources.N6
import gero.composeapp.generated.resources.N7
import gero.composeapp.generated.resources.N8
import gero.composeapp.generated.resources.N9
import gero.composeapp.generated.resources.NL1
import gero.composeapp.generated.resources.NL10
import gero.composeapp.generated.resources.NL11
import gero.composeapp.generated.resources.NL12
import gero.composeapp.generated.resources.NL13
import gero.composeapp.generated.resources.NL14
import gero.composeapp.generated.resources.NL15
import gero.composeapp.generated.resources.NL16
import gero.composeapp.generated.resources.NL17
import gero.composeapp.generated.resources.NL17a
import gero.composeapp.generated.resources.NL18
import gero.composeapp.generated.resources.NL19
import gero.composeapp.generated.resources.NL2
import gero.composeapp.generated.resources.NL20
import gero.composeapp.generated.resources.NL3
import gero.composeapp.generated.resources.NL4
import gero.composeapp.generated.resources.NL5
import gero.composeapp.generated.resources.NL5a
import gero.composeapp.generated.resources.NL6
import gero.composeapp.generated.resources.NL7
import gero.composeapp.generated.resources.NL8
import gero.composeapp.generated.resources.NL9
import gero.composeapp.generated.resources.NU1
import gero.composeapp.generated.resources.NU10
import gero.composeapp.generated.resources.NU10a
import gero.composeapp.generated.resources.NU11
import gero.composeapp.generated.resources.NU11a
import gero.composeapp.generated.resources.NU12
import gero.composeapp.generated.resources.NU13
import gero.composeapp.generated.resources.NU14
import gero.composeapp.generated.resources.NU15
import gero.composeapp.generated.resources.NU16
import gero.composeapp.generated.resources.NU17
import gero.composeapp.generated.resources.NU18
import gero.composeapp.generated.resources.NU18a
import gero.composeapp.generated.resources.NU19
import gero.composeapp.generated.resources.NU2
import gero.composeapp.generated.resources.NU20
import gero.composeapp.generated.resources.NU21
import gero.composeapp.generated.resources.NU22
import gero.composeapp.generated.resources.NU22a
import gero.composeapp.generated.resources.NU3
import gero.composeapp.generated.resources.NU4
import gero.composeapp.generated.resources.NU5
import gero.composeapp.generated.resources.NU6
import gero.composeapp.generated.resources.NU7
import gero.composeapp.generated.resources.NU8
import gero.composeapp.generated.resources.NU9
import gero.composeapp.generated.resources.O1
import gero.composeapp.generated.resources.O10
import gero.composeapp.generated.resources.O10A
import gero.composeapp.generated.resources.O10B
import gero.composeapp.generated.resources.O10C
import gero.composeapp.generated.resources.O11
import gero.composeapp.generated.resources.O12
import gero.composeapp.generated.resources.O13
import gero.composeapp.generated.resources.O14
import gero.composeapp.generated.resources.O15
import gero.composeapp.generated.resources.O16
import gero.composeapp.generated.resources.O17
import gero.composeapp.generated.resources.O18
import gero.composeapp.generated.resources.O19
import gero.composeapp.generated.resources.O19A
import gero.composeapp.generated.resources.O1A
import gero.composeapp.generated.resources.O2
import gero.composeapp.generated.resources.O20
import gero.composeapp.generated.resources.O20A
import gero.composeapp.generated.resources.O21
import gero.composeapp.generated.resources.O22
import gero.composeapp.generated.resources.O23
import gero.composeapp.generated.resources.O24
import gero.composeapp.generated.resources.O24A
import gero.composeapp.generated.resources.O25
import gero.composeapp.generated.resources.O25A
import gero.composeapp.generated.resources.O26
import gero.composeapp.generated.resources.O27
import gero.composeapp.generated.resources.O28
import gero.composeapp.generated.resources.O29
import gero.composeapp.generated.resources.O29A
import gero.composeapp.generated.resources.O3
import gero.composeapp.generated.resources.O30
import gero.composeapp.generated.resources.O30A
import gero.composeapp.generated.resources.O31
import gero.composeapp.generated.resources.O32
import gero.composeapp.generated.resources.O33
import gero.composeapp.generated.resources.O33A
import gero.composeapp.generated.resources.O34
import gero.composeapp.generated.resources.O35
import gero.composeapp.generated.resources.O36
import gero.composeapp.generated.resources.O36A
import gero.composeapp.generated.resources.O36B
import gero.composeapp.generated.resources.O36C
import gero.composeapp.generated.resources.O36D
import gero.composeapp.generated.resources.O37
import gero.composeapp.generated.resources.O38
import gero.composeapp.generated.resources.O39
import gero.composeapp.generated.resources.O4
import gero.composeapp.generated.resources.O40
import gero.composeapp.generated.resources.O41
import gero.composeapp.generated.resources.O42
import gero.composeapp.generated.resources.O43
import gero.composeapp.generated.resources.O44
import gero.composeapp.generated.resources.O45
import gero.composeapp.generated.resources.O46
import gero.composeapp.generated.resources.O47
import gero.composeapp.generated.resources.O48
import gero.composeapp.generated.resources.O49
import gero.composeapp.generated.resources.O5
import gero.composeapp.generated.resources.O50
import gero.composeapp.generated.resources.O50A
import gero.composeapp.generated.resources.O50B
import gero.composeapp.generated.resources.O51
import gero.composeapp.generated.resources.O5A
import gero.composeapp.generated.resources.O6
import gero.composeapp.generated.resources.O6A
import gero.composeapp.generated.resources.O6B
import gero.composeapp.generated.resources.O6C
import gero.composeapp.generated.resources.O6D
import gero.composeapp.generated.resources.O6E
import gero.composeapp.generated.resources.O6F
import gero.composeapp.generated.resources.O7
import gero.composeapp.generated.resources.O8
import gero.composeapp.generated.resources.O9
import gero.composeapp.generated.resources.P1
import gero.composeapp.generated.resources.P10
import gero.composeapp.generated.resources.P11
import gero.composeapp.generated.resources.P1A
import gero.composeapp.generated.resources.P2
import gero.composeapp.generated.resources.P3
import gero.composeapp.generated.resources.P3A
import gero.composeapp.generated.resources.P4
import gero.composeapp.generated.resources.P5
import gero.composeapp.generated.resources.P6
import gero.composeapp.generated.resources.P7
import gero.composeapp.generated.resources.P8
import gero.composeapp.generated.resources.P9
import gero.composeapp.generated.resources.Q1
import gero.composeapp.generated.resources.Q2
import gero.composeapp.generated.resources.Q3
import gero.composeapp.generated.resources.Q4
import gero.composeapp.generated.resources.Q5
import gero.composeapp.generated.resources.Q6
import gero.composeapp.generated.resources.Q7
import gero.composeapp.generated.resources.R1
import gero.composeapp.generated.resources.R10
import gero.composeapp.generated.resources.R10A
import gero.composeapp.generated.resources.R11
import gero.composeapp.generated.resources.R12
import gero.composeapp.generated.resources.R13
import gero.composeapp.generated.resources.R14
import gero.composeapp.generated.resources.R15
import gero.composeapp.generated.resources.R16
import gero.composeapp.generated.resources.R16A
import gero.composeapp.generated.resources.R17
import gero.composeapp.generated.resources.R18
import gero.composeapp.generated.resources.R19
import gero.composeapp.generated.resources.R2
import gero.composeapp.generated.resources.R20
import gero.composeapp.generated.resources.R21
import gero.composeapp.generated.resources.R22
import gero.composeapp.generated.resources.R23
import gero.composeapp.generated.resources.R24
import gero.composeapp.generated.resources.R25
import gero.composeapp.generated.resources.R26
import gero.composeapp.generated.resources.R27
import gero.composeapp.generated.resources.R28
import gero.composeapp.generated.resources.R29
import gero.composeapp.generated.resources.R2A
import gero.composeapp.generated.resources.R3
import gero.composeapp.generated.resources.R3A
import gero.composeapp.generated.resources.R3B
import gero.composeapp.generated.resources.R4
import gero.composeapp.generated.resources.R5
import gero.composeapp.generated.resources.R6
import gero.composeapp.generated.resources.R7
import gero.composeapp.generated.resources.R8
import gero.composeapp.generated.resources.R9
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.S1
import gero.composeapp.generated.resources.S10
import gero.composeapp.generated.resources.S11
import gero.composeapp.generated.resources.S12
import gero.composeapp.generated.resources.S13
import gero.composeapp.generated.resources.S14
import gero.composeapp.generated.resources.S14A
import gero.composeapp.generated.resources.S14B
import gero.composeapp.generated.resources.S15
import gero.composeapp.generated.resources.S16
import gero.composeapp.generated.resources.S17
import gero.composeapp.generated.resources.S17A
import gero.composeapp.generated.resources.S18
import gero.composeapp.generated.resources.S19
import gero.composeapp.generated.resources.S2
import gero.composeapp.generated.resources.S20
import gero.composeapp.generated.resources.S21
import gero.composeapp.generated.resources.S22
import gero.composeapp.generated.resources.S23
import gero.composeapp.generated.resources.S24
import gero.composeapp.generated.resources.S25
import gero.composeapp.generated.resources.S26
import gero.composeapp.generated.resources.S26A
import gero.composeapp.generated.resources.S26B
import gero.composeapp.generated.resources.S27
import gero.composeapp.generated.resources.S28
import gero.composeapp.generated.resources.S29
import gero.composeapp.generated.resources.S2A
import gero.composeapp.generated.resources.S3
import gero.composeapp.generated.resources.S30
import gero.composeapp.generated.resources.S31
import gero.composeapp.generated.resources.S32
import gero.composeapp.generated.resources.S33
import gero.composeapp.generated.resources.S34
import gero.composeapp.generated.resources.S35
import gero.composeapp.generated.resources.S35A
import gero.composeapp.generated.resources.S36
import gero.composeapp.generated.resources.S37
import gero.composeapp.generated.resources.S38
import gero.composeapp.generated.resources.S39
import gero.composeapp.generated.resources.S4
import gero.composeapp.generated.resources.S40
import gero.composeapp.generated.resources.S41
import gero.composeapp.generated.resources.S42
import gero.composeapp.generated.resources.S43
import gero.composeapp.generated.resources.S44
import gero.composeapp.generated.resources.S45
import gero.composeapp.generated.resources.S46
import gero.composeapp.generated.resources.S5
import gero.composeapp.generated.resources.S6
import gero.composeapp.generated.resources.S6A
import gero.composeapp.generated.resources.S7
import gero.composeapp.generated.resources.S8
import gero.composeapp.generated.resources.S9
import gero.composeapp.generated.resources.T1
import gero.composeapp.generated.resources.T10
import gero.composeapp.generated.resources.T11
import gero.composeapp.generated.resources.T11A
import gero.composeapp.generated.resources.T12
import gero.composeapp.generated.resources.T13
import gero.composeapp.generated.resources.T14
import gero.composeapp.generated.resources.T15
import gero.composeapp.generated.resources.T16
import gero.composeapp.generated.resources.T16A
import gero.composeapp.generated.resources.T17
import gero.composeapp.generated.resources.T18
import gero.composeapp.generated.resources.T19
import gero.composeapp.generated.resources.T2
import gero.composeapp.generated.resources.T20
import gero.composeapp.generated.resources.T21
import gero.composeapp.generated.resources.T22
import gero.composeapp.generated.resources.T23
import gero.composeapp.generated.resources.T24
import gero.composeapp.generated.resources.T25
import gero.composeapp.generated.resources.T26
import gero.composeapp.generated.resources.T27
import gero.composeapp.generated.resources.T28
import gero.composeapp.generated.resources.T29
import gero.composeapp.generated.resources.T3
import gero.composeapp.generated.resources.T30
import gero.composeapp.generated.resources.T31
import gero.composeapp.generated.resources.T32
import gero.composeapp.generated.resources.T32A
import gero.composeapp.generated.resources.T33
import gero.composeapp.generated.resources.T33A
import gero.composeapp.generated.resources.T34
import gero.composeapp.generated.resources.T35
import gero.composeapp.generated.resources.T36
import gero.composeapp.generated.resources.T3A
import gero.composeapp.generated.resources.T4
import gero.composeapp.generated.resources.T5
import gero.composeapp.generated.resources.T6
import gero.composeapp.generated.resources.T7
import gero.composeapp.generated.resources.T7A
import gero.composeapp.generated.resources.T8
import gero.composeapp.generated.resources.T8A
import gero.composeapp.generated.resources.T9
import gero.composeapp.generated.resources.T9A
import gero.composeapp.generated.resources.U1
import gero.composeapp.generated.resources.U10
import gero.composeapp.generated.resources.U11
import gero.composeapp.generated.resources.U12
import gero.composeapp.generated.resources.U13
import gero.composeapp.generated.resources.U14
import gero.composeapp.generated.resources.U15
import gero.composeapp.generated.resources.U16
import gero.composeapp.generated.resources.U17
import gero.composeapp.generated.resources.U18
import gero.composeapp.generated.resources.U19
import gero.composeapp.generated.resources.U2
import gero.composeapp.generated.resources.U20
import gero.composeapp.generated.resources.U21
import gero.composeapp.generated.resources.U22
import gero.composeapp.generated.resources.U23
import gero.composeapp.generated.resources.U23A
import gero.composeapp.generated.resources.U24
import gero.composeapp.generated.resources.U25
import gero.composeapp.generated.resources.U26
import gero.composeapp.generated.resources.U27
import gero.composeapp.generated.resources.U28
import gero.composeapp.generated.resources.U29
import gero.composeapp.generated.resources.U29A
import gero.composeapp.generated.resources.U3
import gero.composeapp.generated.resources.U30
import gero.composeapp.generated.resources.U31
import gero.composeapp.generated.resources.U32
import gero.composeapp.generated.resources.U32A
import gero.composeapp.generated.resources.U33
import gero.composeapp.generated.resources.U34
import gero.composeapp.generated.resources.U35
import gero.composeapp.generated.resources.U36
import gero.composeapp.generated.resources.U37
import gero.composeapp.generated.resources.U38
import gero.composeapp.generated.resources.U39
import gero.composeapp.generated.resources.U4
import gero.composeapp.generated.resources.U40
import gero.composeapp.generated.resources.U41
import gero.composeapp.generated.resources.U42
import gero.composeapp.generated.resources.U5
import gero.composeapp.generated.resources.U6
import gero.composeapp.generated.resources.U6A
import gero.composeapp.generated.resources.U6B
import gero.composeapp.generated.resources.U7
import gero.composeapp.generated.resources.U8
import gero.composeapp.generated.resources.U9
import gero.composeapp.generated.resources.V1
import gero.composeapp.generated.resources.V10
import gero.composeapp.generated.resources.V11
import gero.composeapp.generated.resources.V11A
import gero.composeapp.generated.resources.V11B
import gero.composeapp.generated.resources.V11C
import gero.composeapp.generated.resources.V12
import gero.composeapp.generated.resources.V12A
import gero.composeapp.generated.resources.V12B
import gero.composeapp.generated.resources.V13
import gero.composeapp.generated.resources.V14
import gero.composeapp.generated.resources.V15
import gero.composeapp.generated.resources.V16
import gero.composeapp.generated.resources.V17
import gero.composeapp.generated.resources.V18
import gero.composeapp.generated.resources.V19
import gero.composeapp.generated.resources.V1A
import gero.composeapp.generated.resources.V1B
import gero.composeapp.generated.resources.V1C
import gero.composeapp.generated.resources.V1D
import gero.composeapp.generated.resources.V1E
import gero.composeapp.generated.resources.V1F
import gero.composeapp.generated.resources.V1G
import gero.composeapp.generated.resources.V1H
import gero.composeapp.generated.resources.V1I
import gero.composeapp.generated.resources.V2
import gero.composeapp.generated.resources.V20
import gero.composeapp.generated.resources.V20A
import gero.composeapp.generated.resources.V20B
import gero.composeapp.generated.resources.V20C
import gero.composeapp.generated.resources.V20D
import gero.composeapp.generated.resources.V20E
import gero.composeapp.generated.resources.V20F
import gero.composeapp.generated.resources.V20G
import gero.composeapp.generated.resources.V20H
import gero.composeapp.generated.resources.V20I
import gero.composeapp.generated.resources.V20J
import gero.composeapp.generated.resources.V20K
import gero.composeapp.generated.resources.V20L
import gero.composeapp.generated.resources.V21
import gero.composeapp.generated.resources.V22
import gero.composeapp.generated.resources.V23
import gero.composeapp.generated.resources.V23A
import gero.composeapp.generated.resources.V24
import gero.composeapp.generated.resources.V25
import gero.composeapp.generated.resources.V26
import gero.composeapp.generated.resources.V27
import gero.composeapp.generated.resources.V28
import gero.composeapp.generated.resources.V28A
import gero.composeapp.generated.resources.V29
import gero.composeapp.generated.resources.V29A
import gero.composeapp.generated.resources.V2A
import gero.composeapp.generated.resources.V3
import gero.composeapp.generated.resources.V30
import gero.composeapp.generated.resources.V30A
import gero.composeapp.generated.resources.V31
import gero.composeapp.generated.resources.V31A
import gero.composeapp.generated.resources.V32
import gero.composeapp.generated.resources.V33
import gero.composeapp.generated.resources.V33A
import gero.composeapp.generated.resources.V34
import gero.composeapp.generated.resources.V35
import gero.composeapp.generated.resources.V36
import gero.composeapp.generated.resources.V37
import gero.composeapp.generated.resources.V37A
import gero.composeapp.generated.resources.V38
import gero.composeapp.generated.resources.V39
import gero.composeapp.generated.resources.V4
import gero.composeapp.generated.resources.V40
import gero.composeapp.generated.resources.V40A
import gero.composeapp.generated.resources.V5
import gero.composeapp.generated.resources.V6
import gero.composeapp.generated.resources.V7
import gero.composeapp.generated.resources.V7A
import gero.composeapp.generated.resources.V7B
import gero.composeapp.generated.resources.V8
import gero.composeapp.generated.resources.V9
import gero.composeapp.generated.resources.W1
import gero.composeapp.generated.resources.W10
import gero.composeapp.generated.resources.W10A
import gero.composeapp.generated.resources.W11
import gero.composeapp.generated.resources.W12
import gero.composeapp.generated.resources.W13
import gero.composeapp.generated.resources.W14
import gero.composeapp.generated.resources.W14A
import gero.composeapp.generated.resources.W15
import gero.composeapp.generated.resources.W16
import gero.composeapp.generated.resources.W17
import gero.composeapp.generated.resources.W17A
import gero.composeapp.generated.resources.W18
import gero.composeapp.generated.resources.W18A
import gero.composeapp.generated.resources.W19
import gero.composeapp.generated.resources.W2
import gero.composeapp.generated.resources.W20
import gero.composeapp.generated.resources.W21
import gero.composeapp.generated.resources.W22
import gero.composeapp.generated.resources.W23
import gero.composeapp.generated.resources.W24
import gero.composeapp.generated.resources.W24A
import gero.composeapp.generated.resources.W25
import gero.composeapp.generated.resources.W3
import gero.composeapp.generated.resources.W3A
import gero.composeapp.generated.resources.W4
import gero.composeapp.generated.resources.W5
import gero.composeapp.generated.resources.W6
import gero.composeapp.generated.resources.W7
import gero.composeapp.generated.resources.W8
import gero.composeapp.generated.resources.W9
import gero.composeapp.generated.resources.W9A
import gero.composeapp.generated.resources.X1
import gero.composeapp.generated.resources.X1D46
import gero.composeapp.generated.resources.X2
import gero.composeapp.generated.resources.X3
import gero.composeapp.generated.resources.X4
import gero.composeapp.generated.resources.X4A
import gero.composeapp.generated.resources.X4B
import gero.composeapp.generated.resources.X5
import gero.composeapp.generated.resources.X6
import gero.composeapp.generated.resources.X6A
import gero.composeapp.generated.resources.X7
import gero.composeapp.generated.resources.X8
import gero.composeapp.generated.resources.X8A
import gero.composeapp.generated.resources.Y1
import gero.composeapp.generated.resources.Y1A
import gero.composeapp.generated.resources.Y2
import gero.composeapp.generated.resources.Y3
import gero.composeapp.generated.resources.Y4
import gero.composeapp.generated.resources.Y5
import gero.composeapp.generated.resources.Y6
import gero.composeapp.generated.resources.Y7
import gero.composeapp.generated.resources.Y8
import gero.composeapp.generated.resources.Z1
import gero.composeapp.generated.resources.Z10
import gero.composeapp.generated.resources.Z11
import gero.composeapp.generated.resources.Z12
import gero.composeapp.generated.resources.Z13
import gero.composeapp.generated.resources.Z14
import gero.composeapp.generated.resources.Z15
import gero.composeapp.generated.resources.Z15A
import gero.composeapp.generated.resources.Z15B
import gero.composeapp.generated.resources.Z15C
import gero.composeapp.generated.resources.Z15D
import gero.composeapp.generated.resources.Z15E
import gero.composeapp.generated.resources.Z15F
import gero.composeapp.generated.resources.Z15G
import gero.composeapp.generated.resources.Z15H
import gero.composeapp.generated.resources.Z15I
import gero.composeapp.generated.resources.Z16
import gero.composeapp.generated.resources.Z16A
import gero.composeapp.generated.resources.Z16B
import gero.composeapp.generated.resources.Z16C
import gero.composeapp.generated.resources.Z16D
import gero.composeapp.generated.resources.Z16E
import gero.composeapp.generated.resources.Z16F
import gero.composeapp.generated.resources.Z16G
import gero.composeapp.generated.resources.Z16H
import gero.composeapp.generated.resources.Z2
import gero.composeapp.generated.resources.Z2A
import gero.composeapp.generated.resources.Z2B
import gero.composeapp.generated.resources.Z2C
import gero.composeapp.generated.resources.Z2D
import gero.composeapp.generated.resources.Z3
import gero.composeapp.generated.resources.Z3A
import gero.composeapp.generated.resources.Z3B
import gero.composeapp.generated.resources.Z4
import gero.composeapp.generated.resources.Z4A
import gero.composeapp.generated.resources.Z5
import gero.composeapp.generated.resources.Z5A
import gero.composeapp.generated.resources.Z6
import gero.composeapp.generated.resources.Z7
import gero.composeapp.generated.resources.Z8
import gero.composeapp.generated.resources.Z9
import org.jetbrains.compose.resources.DrawableResource

data class Hiero(
    val gardinerCode: String,
    val unicode: String,
    val transliteration: String,
    val ideogramma: String,
    val determinativo: String,
    val mnemonico: String,
    val ideogrammaEn: String,
    val determinativoEn: String,
    val mnemonicoEn: String,
    val ideogrammaDe: String = "",
    val determinativoDe: String = "",
    val mnemonicoDe: String = "",
    val ideogrammaEs: String = "",
    val determinativoEs: String = "",
    val mnemonicoEs: String = "",
    val ideogrammaFr: String = "",
    val determinativoFr: String = "",
    val mnemonicoFr: String = ""
) {
    /**
     * Returns the ideogram text in the appropriate language based on the locale.
     * @param languageCode the language code (e.g., "it", "en", "de", "es", "fr")
     * @return the ideogram text in the specified language
     */
    fun getIdeogramma(languageCode: String): String {
        return when (languageCode) {
            "it" -> ideogramma
            "de" -> ideogrammaDe.ifBlank { ideogrammaEn }
            "es" -> ideogrammaEs.ifBlank { ideogrammaEn }
            "fr" -> ideogrammaFr.ifBlank { ideogrammaEn }
            else -> ideogrammaEn
        }
    }

    /**
     * Returns the determinative text in the appropriate language based on the locale.
     * @param languageCode the language code (e.g., "it", "en", "de", "es", "fr")
     * @return the determinative text in the specified language
     */
    fun getDeterminativo(languageCode: String): String {
        return when (languageCode) {
            "it" -> determinativo
            "de" -> determinativoDe.ifBlank { determinativoEn }
            "es" -> determinativoEs.ifBlank { determinativoEn }
            "fr" -> determinativoFr.ifBlank { determinativoEn }
            else -> determinativoEn
        }
    }

    /**
     * Returns the mnemonic text in the appropriate language based on the locale.
     * @param languageCode the language code (e.g., "it", "en", "de", "es", "fr")
     * @return the mnemonic text in the specified language
     */
    fun getMnemonico(languageCode: String): String {
        return when (languageCode) {
            "it" -> mnemonico
            "de" -> mnemonicoDe.ifBlank { mnemonicoEn }
            "es" -> mnemonicoEs.ifBlank { mnemonicoEn }
            "fr" -> mnemonicoFr.ifBlank { mnemonicoEn }
            else -> mnemonicoEn
        }
    }
}

object UniliteralRepository {

    fun resFromGardinerCode(code: String): DrawableResource? {
        return resToGardinerCode[code]
    }

    val resToGardinerCode = mapOf(
        "A1" to Res.drawable.A1,
        "A2" to Res.drawable.A2,
        "A3" to Res.drawable.A3,
        "A4" to Res.drawable.A4,
        "A5" to Res.drawable.A5,
        "A5A" to Res.drawable.A5A,
        "A6" to Res.drawable.A6,
        "A6A" to Res.drawable.A6A,
        "A6B" to Res.drawable.A6B,
        "A7" to Res.drawable.A7,
        "A8" to Res.drawable.A8,
        "A9" to Res.drawable.A9,
        "A10" to Res.drawable.A10,
        "A11" to Res.drawable.A11,
        "A12" to Res.drawable.A12,
        "A13" to Res.drawable.A13,
        "A14" to Res.drawable.A14,
        "A14A" to Res.drawable.A14A,
        "A15" to Res.drawable.A15,
        "A16" to Res.drawable.A16,
        "A17" to Res.drawable.A17,
        "A17A" to Res.drawable.A17A,
        "A18" to Res.drawable.A18,
        "A19" to Res.drawable.A19,
        "A20" to Res.drawable.A20,
        "A21" to Res.drawable.A21,
        "A22" to Res.drawable.A22,
        "A23" to Res.drawable.A23,
        "A24" to Res.drawable.A24,
        "A25" to Res.drawable.A25,
        "A26" to Res.drawable.A26,
        "A27" to Res.drawable.A27,
        "A28" to Res.drawable.A28,
        "A29" to Res.drawable.A29,
        "A30" to Res.drawable.A30,
        "A31" to Res.drawable.A31,
        "A32" to Res.drawable.A32,
        "A32A" to Res.drawable.A32A,
        "A33" to Res.drawable.A33,
        "A34" to Res.drawable.A34,
        "A35" to Res.drawable.A35,
        "A36" to Res.drawable.A36,
        "A37" to Res.drawable.A37,
        "A38" to Res.drawable.A38,
        "A39" to Res.drawable.A39,
        "A40" to Res.drawable.A40,
        "A40A" to Res.drawable.A40A,
        "A41" to Res.drawable.A41,
        "A42" to Res.drawable.A42,
        "A42A" to Res.drawable.A42A,
        "A43" to Res.drawable.A43,
        "A43A" to Res.drawable.A43A,
        "A44" to Res.drawable.A44,
        "A45" to Res.drawable.A45,
        "A45A" to Res.drawable.A45A,
        "A46" to Res.drawable.A46,
        "A47" to Res.drawable.A47,
        "A48" to Res.drawable.A48,
        "A49" to Res.drawable.A49,
        "A50" to Res.drawable.A50,
        "A51" to Res.drawable.A51,
        "A52" to Res.drawable.A52,
        "A53" to Res.drawable.A53,
        "A54" to Res.drawable.A54,
        "A55" to Res.drawable.A55,
        "A56" to Res.drawable.A56,
        "A57" to Res.drawable.A57,
        "A58" to Res.drawable.A58,
        "A59" to Res.drawable.A59,
        "A60" to Res.drawable.A60,
        "A61" to Res.drawable.A61,
        "A62" to Res.drawable.A62,
        "A63" to Res.drawable.A63,
        "A64" to Res.drawable.A64,
        "A65" to Res.drawable.A65,
        "A66" to Res.drawable.A66,
        "A67" to Res.drawable.A67,
        "A68" to Res.drawable.A68,
        "A69" to Res.drawable.A69,
        "A70" to Res.drawable.A70,
        "B1" to Res.drawable.B1,
        "B2" to Res.drawable.B2,
        "B3" to Res.drawable.B3,
        "B4" to Res.drawable.B4,
        "B5" to Res.drawable.B5,
        "B5A" to Res.drawable.B5A,
        "B6" to Res.drawable.B6,
        "B7" to Res.drawable.B7,
        "B8" to Res.drawable.B8,
        "B9" to Res.drawable.B9,
        "C1" to Res.drawable.C1,
        "C2" to Res.drawable.C2,
        "C2A" to Res.drawable.C2A,
        "C2B" to Res.drawable.C2B,
        "C2C" to Res.drawable.C2C,
        "C3" to Res.drawable.C3,
        "C4" to Res.drawable.C4,
        "C5" to Res.drawable.C5,
        "C6" to Res.drawable.C6,
        "C7" to Res.drawable.C7,
        "C8" to Res.drawable.C8,
        "C9" to Res.drawable.C9,
        "C10" to Res.drawable.C10,
        "C10A" to Res.drawable.C10A,
        "C11" to Res.drawable.C11,
        "C12" to Res.drawable.C12,
        "C13" to Res.drawable.C13,
        "C14" to Res.drawable.C14,
        "C15" to Res.drawable.C15,
        "C16" to Res.drawable.C16,
        "C17" to Res.drawable.C17,
        "C18" to Res.drawable.C18,
        "C19" to Res.drawable.C19,
        "C20" to Res.drawable.C20,
        "C21" to Res.drawable.C21,
        "C22" to Res.drawable.C22,
        "C23" to Res.drawable.C23,
        "C24" to Res.drawable.C24,
        "D1" to Res.drawable.D1,
        "D2" to Res.drawable.D2,
        "D3" to Res.drawable.D3,
        "D4" to Res.drawable.D4,
        "D5" to Res.drawable.D5,
        "D6" to Res.drawable.D6,
        "D7" to Res.drawable.D7,
        "D8" to Res.drawable.D8,
        "D8A" to Res.drawable.D8A,
        "D9" to Res.drawable.D9,
        "D10" to Res.drawable.D10,
        "D11" to Res.drawable.D11,
        "D12" to Res.drawable.D12,
        "D13" to Res.drawable.D13,
        "D14" to Res.drawable.D14,
        "D15" to Res.drawable.D15,
        "D16" to Res.drawable.D16,
        "D17" to Res.drawable.D17,
        "D18" to Res.drawable.D18,
        "D19" to Res.drawable.D19,
        "D20" to Res.drawable.D20,
        "D21" to Res.drawable.D21,
        "D22" to Res.drawable.D22,
        "D23" to Res.drawable.D23,
        "D24" to Res.drawable.D24,
        "D25" to Res.drawable.D25,
        "D26" to Res.drawable.D26,
        "D27" to Res.drawable.D27,
        "D27A" to Res.drawable.D27A,
        "D28" to Res.drawable.D28,
        "D29" to Res.drawable.D29,
        "D30" to Res.drawable.D30,
        "D31" to Res.drawable.D31,
        "D31A" to Res.drawable.D31A,
        "D32" to Res.drawable.D32,
        "D33" to Res.drawable.D33,
        "D34" to Res.drawable.D34,
        "D34A" to Res.drawable.D34A,
        "D35" to Res.drawable.D35,
        "D36" to Res.drawable.D36,
        "D37" to Res.drawable.D37,
        "D38" to Res.drawable.D38,
        "D39" to Res.drawable.D39,
        "D40" to Res.drawable.D40,
        "D41" to Res.drawable.D41,
        "D42" to Res.drawable.D42,
        "D43" to Res.drawable.D43,
        "D44" to Res.drawable.D44,
        "D45" to Res.drawable.D45,
        "D46" to Res.drawable.D46,
        "D46A" to Res.drawable.D46A,
        "D47" to Res.drawable.D47,
        "D48" to Res.drawable.D48,
        "D48A" to Res.drawable.D48A,
        "D49" to Res.drawable.D49,
        "D50" to Res.drawable.D50,
        "D50A" to Res.drawable.D50A,
        "D50B" to Res.drawable.D50B,
        "D50C" to Res.drawable.D50C,
        "D50D" to Res.drawable.D50D,
        "D50E" to Res.drawable.D50E,
        "D50F" to Res.drawable.D50F,
        "D50G" to Res.drawable.D50G,
        "D50H" to Res.drawable.D50H,
        "D50I" to Res.drawable.D50I,
        "D51" to Res.drawable.D51,
        "D52" to Res.drawable.D52,
        "D52A" to Res.drawable.D52A,
        "D53" to Res.drawable.D53,
        "D54" to Res.drawable.D54,
        "D54A" to Res.drawable.D54A,
        "D55" to Res.drawable.D55,
        "D56" to Res.drawable.D56,
        "D57" to Res.drawable.D57,
        "D58" to Res.drawable.D58,
        "D59" to Res.drawable.D59,
        "D60" to Res.drawable.D60,
        "D61" to Res.drawable.D61,
        "D62" to Res.drawable.D62,
        "D63" to Res.drawable.D63,
        "D64" to Res.drawable.D64,
        "D65" to Res.drawable.D65,
        "D66" to Res.drawable.D66,
        "D67" to Res.drawable.D67,
        "D67A" to Res.drawable.D67A,
        "D67B" to Res.drawable.D67B,
        "D67C" to Res.drawable.D67C,
        "D67D" to Res.drawable.D67D,
        "D67E" to Res.drawable.D67E,
        "D67F" to Res.drawable.D67F,
        "D67G" to Res.drawable.D67G,
        "D67H" to Res.drawable.D67H,
        "E1" to Res.drawable.E1,
        "E2" to Res.drawable.E2,
        "E3" to Res.drawable.E3,
        "E4" to Res.drawable.E4,
        "E5" to Res.drawable.E5,
        "E6" to Res.drawable.E6,
        "E7" to Res.drawable.E7,
        "E8" to Res.drawable.E8,
        "E8A" to Res.drawable.E8A,
        "E9" to Res.drawable.E9,
        "E9A" to Res.drawable.E9A,
        "E10" to Res.drawable.E10,
        "E11" to Res.drawable.E11,
        "E12" to Res.drawable.E12,
        "E13" to Res.drawable.E13,
        "E14" to Res.drawable.E14,
        "E15" to Res.drawable.E15,
        "E16" to Res.drawable.E16,
        "E16A" to Res.drawable.E16A,
        "E17" to Res.drawable.E17,
        "E17A" to Res.drawable.E17A,
        "E18" to Res.drawable.E18,
        "E19" to Res.drawable.E19,
        "E20" to Res.drawable.E20,
        "E20A" to Res.drawable.E20A,
        "E21" to Res.drawable.E21,
        "E22" to Res.drawable.E22,
        "E23" to Res.drawable.E23,
        "E24" to Res.drawable.E24,
        "E25" to Res.drawable.E25,
        "E26" to Res.drawable.E26,
        "E27" to Res.drawable.E27,
        "E28" to Res.drawable.E28,
        "E28A" to Res.drawable.E28A,
        "E29" to Res.drawable.E29,
        "E30" to Res.drawable.E30,
        "E31" to Res.drawable.E31,
        "E32" to Res.drawable.E32,
        "E33" to Res.drawable.E33,
        "E34" to Res.drawable.E34,
        "E34A" to Res.drawable.E34A,
        "E36" to Res.drawable.E36,
        "E37" to Res.drawable.E37,
        "E38" to Res.drawable.E38,
        "F1" to Res.drawable.F1,
        "F1A" to Res.drawable.F1A,
        "F2" to Res.drawable.F2,
        "F3" to Res.drawable.F3,
        "F4" to Res.drawable.F4,
        "F5" to Res.drawable.F5,
        "F6" to Res.drawable.F6,
        "F7" to Res.drawable.F7,
        "F8" to Res.drawable.F8,
        "F9" to Res.drawable.F9,
        "F10" to Res.drawable.F10,
        "F11" to Res.drawable.F11,
        "F12" to Res.drawable.F12,
        "F13" to Res.drawable.F13,
        "F13A" to Res.drawable.F13A,
        "F14" to Res.drawable.F14,
        "F15" to Res.drawable.F15,
        "F16" to Res.drawable.F16,
        "F17" to Res.drawable.F17,
        "F18" to Res.drawable.F18,
        "F19" to Res.drawable.F19,
        "F20" to Res.drawable.F20,
        "F21" to Res.drawable.F21,
        "F21A" to Res.drawable.F21A,
        "F22" to Res.drawable.F22,
        "F23" to Res.drawable.F23,
        "F24" to Res.drawable.F24,
        "F25" to Res.drawable.F25,
        "F26" to Res.drawable.F26,
        "F27" to Res.drawable.F27,
        "F28" to Res.drawable.F28,
        "F29" to Res.drawable.F29,
        "F30" to Res.drawable.F30,
        "F31" to Res.drawable.F31,
        "F31A" to Res.drawable.F31A,
        "F32" to Res.drawable.F32,
        "F33" to Res.drawable.F33,
        "F34" to Res.drawable.F34,
        "F35" to Res.drawable.F35,
        "F36" to Res.drawable.F36,
        "F37" to Res.drawable.F37,
        "F37A" to Res.drawable.F37A,
        "F38" to Res.drawable.F38,
        "F38A" to Res.drawable.F38A,
        "F39" to Res.drawable.F39,
        "F40" to Res.drawable.F40,
        "F41" to Res.drawable.F41,
        "F42" to Res.drawable.F42,
        "F43" to Res.drawable.F43,
        "F44" to Res.drawable.F44,
        "F45" to Res.drawable.F45,
        "F45A" to Res.drawable.F45A,
        "F46" to Res.drawable.F46,
        "F46A" to Res.drawable.F46A,
        "F47" to Res.drawable.F47,
        "F47A" to Res.drawable.F47A,
        "F48" to Res.drawable.F48,
        "F49" to Res.drawable.F49,
        "F50" to Res.drawable.F50,
        "F51" to Res.drawable.F51,
        "F51A" to Res.drawable.F51A,
        "F51B" to Res.drawable.F51B,
        "F51C" to Res.drawable.F51C,
        "F52" to Res.drawable.F52,
        "F53" to Res.drawable.F53,
        "G1" to Res.drawable.G1,
        "G2" to Res.drawable.G2,
        "G3" to Res.drawable.G3,
        "G4" to Res.drawable.G4,
        "G5" to Res.drawable.G5,
        "G6" to Res.drawable.G6,
        "G6A" to Res.drawable.G6A,
        "G7" to Res.drawable.G7,
        "G7A" to Res.drawable.G7A,
        "G7B" to Res.drawable.G7B,
        "G8" to Res.drawable.G8,
        "G9" to Res.drawable.G9,
        "G10" to Res.drawable.G10,
        "G11" to Res.drawable.G11,
        "G11A" to Res.drawable.G11A,
        "G12" to Res.drawable.G12,
        "G13" to Res.drawable.G13,
        "G14" to Res.drawable.G14,
        "G15" to Res.drawable.G15,
        "G16" to Res.drawable.G16,
        "G17" to Res.drawable.G17,
        "G18" to Res.drawable.G18,
        "G19" to Res.drawable.G19,
        "G20" to Res.drawable.G20,
        "G20A" to Res.drawable.G20A,
        "G21" to Res.drawable.G21,
        "G22" to Res.drawable.G22,
        "G23" to Res.drawable.G23,
        "G24" to Res.drawable.G24,
        "G25" to Res.drawable.G25,
        "G26" to Res.drawable.G26,
        "G26A" to Res.drawable.G26A,
        "G27" to Res.drawable.G27,
        "G28" to Res.drawable.G28,
        "G29" to Res.drawable.G29,
        "G30" to Res.drawable.G30,
        "G31" to Res.drawable.G31,
        "G32" to Res.drawable.G32,
        "G33" to Res.drawable.G33,
        "G34" to Res.drawable.G34,
        "G35" to Res.drawable.G35,
        "G36" to Res.drawable.G36,
        "G36A" to Res.drawable.G36A,
        "G37" to Res.drawable.G37,
        "G37A" to Res.drawable.G37A,
        "G38" to Res.drawable.G38,
        "G39" to Res.drawable.G39,
        "G39X1" to Res.drawable.G39X1,
        "G40" to Res.drawable.G40,
        "G41" to Res.drawable.G41,
        "G42" to Res.drawable.G42,
        "G43" to Res.drawable.G43,
        "G43A" to Res.drawable.G43A,
        "G43B" to Res.drawable.G43B,
        "G44" to Res.drawable.G44,
        "G45" to Res.drawable.G45,
        "G45A" to Res.drawable.G45A,
        "G46" to Res.drawable.G46,
        "G47" to Res.drawable.G47,
        "G48" to Res.drawable.G48,
        "G49" to Res.drawable.G49,
        "G50" to Res.drawable.G50,
        "G51" to Res.drawable.G51,
        "G52" to Res.drawable.G52,
        "G53" to Res.drawable.G53,
        "G54" to Res.drawable.G54,
        "H1" to Res.drawable.H1,
        "H2" to Res.drawable.H2,
        "H3" to Res.drawable.H3,
        "H4" to Res.drawable.H4,
        "H5" to Res.drawable.H5,
        "H6" to Res.drawable.H6,
        "H6A" to Res.drawable.H6A,
        "H7" to Res.drawable.H7,
        "H8" to Res.drawable.H8,
        "I1" to Res.drawable.I1,
        "I2" to Res.drawable.I2,
        "I3" to Res.drawable.I3,
        "I4" to Res.drawable.I4,
        "I5" to Res.drawable.I5,
        "I5A" to Res.drawable.I5A,
        "I6" to Res.drawable.I6,
        "I7" to Res.drawable.I7,
        "I8" to Res.drawable.I8,
        "I9" to Res.drawable.I9,
        "I9A" to Res.drawable.I9A,
        "I10" to Res.drawable.I10,
        "I10A" to Res.drawable.I10A,
        "I11" to Res.drawable.I11,
        "I11A" to Res.drawable.I11A,
        "I12" to Res.drawable.I12,
        "I13" to Res.drawable.I13,
        "I14" to Res.drawable.I14,
        "I15" to Res.drawable.I15,
        "K1" to Res.drawable.K1,
        "K2" to Res.drawable.K2,
        "K3" to Res.drawable.K3,
        "K4" to Res.drawable.K4,
        "K5" to Res.drawable.K5,
        "K6" to Res.drawable.K6,
        "K7" to Res.drawable.K7,
        "K8" to Res.drawable.K8,
        "L1" to Res.drawable.L1,
        "L2" to Res.drawable.L2,
        "L2A" to Res.drawable.L2A,
        "L3" to Res.drawable.L3,
        "L4" to Res.drawable.L4,
        "L5" to Res.drawable.L5,
        "L6" to Res.drawable.L6,
        "L6A" to Res.drawable.L6A,
        "L7" to Res.drawable.L7,
        "L8" to Res.drawable.L8,
        "M1" to Res.drawable.M1,
        "M1A" to Res.drawable.M1A,
        "M1B" to Res.drawable.M1B,
        "M2" to Res.drawable.M2,
        "M3" to Res.drawable.M3,
        "M3A" to Res.drawable.M3A,
        "M4" to Res.drawable.M4,
        "M5" to Res.drawable.M5,
        "M6" to Res.drawable.M6,
        "M7" to Res.drawable.M7,
        "M8" to Res.drawable.M8,
        "M9" to Res.drawable.M9,
        "M10" to Res.drawable.M10,
        "M10A" to Res.drawable.M10A,
        "M11" to Res.drawable.M11,
        "M12" to Res.drawable.M12,
        "M12A" to Res.drawable.M12A,
        "M12B" to Res.drawable.M12B,
        "M12C" to Res.drawable.M12C,
        "M12D" to Res.drawable.M12D,
        "M12E" to Res.drawable.M12E,
        "M12F" to Res.drawable.M12F,
        "M12G" to Res.drawable.M12G,
        "M12H" to Res.drawable.M12H,
        "M13" to Res.drawable.M13,
        "M14" to Res.drawable.M14,
        "M15" to Res.drawable.M15,
        "M15A" to Res.drawable.M15A,
        "M16" to Res.drawable.M16,
        "M16A" to Res.drawable.M16A,
        "M17" to Res.drawable.M17,
        "M17A" to Res.drawable.M17A,
        "M18" to Res.drawable.M18,
        "M19" to Res.drawable.M19,
        "M20" to Res.drawable.M20,
        "M21" to Res.drawable.M21,
        "M22" to Res.drawable.M22,
        "M22A" to Res.drawable.M22A,
        "M23" to Res.drawable.M23,
        "M24" to Res.drawable.M24,
        "M24A" to Res.drawable.M24A,
        "M25" to Res.drawable.M25,
        "M26" to Res.drawable.M26,
        "M27" to Res.drawable.M27,
        "M28" to Res.drawable.M28,
        "M28A" to Res.drawable.M28A,
        "M29" to Res.drawable.M29,
        "M30" to Res.drawable.M30,
        "M31" to Res.drawable.M31,
        "M31A" to Res.drawable.M31A,
        "M32" to Res.drawable.M32,
        "M33" to Res.drawable.M33,
        "M33A" to Res.drawable.M33A,
        "M33B" to Res.drawable.M33B,
        "M34" to Res.drawable.M34,
        "M35" to Res.drawable.M35,
        "M36" to Res.drawable.M36,
        "M37" to Res.drawable.M37,
        "M38" to Res.drawable.M38,
        "M39" to Res.drawable.M39,
        "M40" to Res.drawable.M40,
        "M40A" to Res.drawable.M40A,
        "M41" to Res.drawable.M41,
        "M42" to Res.drawable.M42,
        "M43" to Res.drawable.M43,
        "M44" to Res.drawable.M44,
        "N1" to Res.drawable.N1,
        "N2" to Res.drawable.N2,
        "N3" to Res.drawable.N3,
        "N4" to Res.drawable.N4,
        "N5" to Res.drawable.N5,
        "N6" to Res.drawable.N6,
        "N7" to Res.drawable.N7,
        "N8" to Res.drawable.N8,
        "N9" to Res.drawable.N9,
        "N10" to Res.drawable.N10,
        "N11" to Res.drawable.N11,
        "N12" to Res.drawable.N12,
        "N13" to Res.drawable.N13,
        "N14" to Res.drawable.N14,
        "N15" to Res.drawable.N15,
        "N16" to Res.drawable.N16,
        "N17" to Res.drawable.N17,
        "N18" to Res.drawable.N18,
        "N18A" to Res.drawable.N18A,
        "N18B" to Res.drawable.N18B,
        "N19" to Res.drawable.N19,
        "N20" to Res.drawable.N20,
        "N21" to Res.drawable.N21,
        "N22" to Res.drawable.N22,
        "N23" to Res.drawable.N23,
        "N24" to Res.drawable.N24,
        "N25" to Res.drawable.N25,
        "N25A" to Res.drawable.N25A,
        "N26" to Res.drawable.N26,
        "N27" to Res.drawable.N27,
        "N28" to Res.drawable.N28,
        "N29" to Res.drawable.N29,
        "N30" to Res.drawable.N30,
        "N31" to Res.drawable.N31,
        "N32" to Res.drawable.N32,
        "N33" to Res.drawable.N33,
        "N33A" to Res.drawable.N33A,
        "N34" to Res.drawable.N34,
        "N34A" to Res.drawable.N34A,
        "N35" to Res.drawable.N35,
        "N35A" to Res.drawable.N35A,
        "N36" to Res.drawable.N36,
        "N37" to Res.drawable.N37,
        "N37A" to Res.drawable.N37A,
        "N38" to Res.drawable.N38,
        "N39" to Res.drawable.N39,
        "N40" to Res.drawable.N40,
        "N41" to Res.drawable.N41,
        "N42" to Res.drawable.N42,
        "NL1" to Res.drawable.NL1,
        "NL2" to Res.drawable.NL2,
        "NL3" to Res.drawable.NL3,
        "NL4" to Res.drawable.NL4,
        "NL5" to Res.drawable.NL5,
        "NL5a" to Res.drawable.NL5a,
        "NL6" to Res.drawable.NL6,
        "NL7" to Res.drawable.NL7,
        "NL8" to Res.drawable.NL8,
        "NL9" to Res.drawable.NL9,
        "NL10" to Res.drawable.NL10,
        "NL11" to Res.drawable.NL11,
        "NL12" to Res.drawable.NL12,
        "NL13" to Res.drawable.NL13,
        "NL14" to Res.drawable.NL14,
        "NL15" to Res.drawable.NL15,
        "NL16" to Res.drawable.NL16,
        "NL17" to Res.drawable.NL17,
        "NL17a" to Res.drawable.NL17a,
        "NL18" to Res.drawable.NL18,
        "NL19" to Res.drawable.NL19,
        "NL20" to Res.drawable.NL20,
        "NU1" to Res.drawable.NU1,
        "NU2" to Res.drawable.NU2,
        "NU3" to Res.drawable.NU3,
        "NU4" to Res.drawable.NU4,
        "NU5" to Res.drawable.NU5,
        "NU6" to Res.drawable.NU6,
        "NU7" to Res.drawable.NU7,
        "NU8" to Res.drawable.NU8,
        "NU9" to Res.drawable.NU9,
        "NU10" to Res.drawable.NU10,
        "NU10a" to Res.drawable.NU10a,
        "NU11" to Res.drawable.NU11,
        "NU11a" to Res.drawable.NU11a,
        "NU12" to Res.drawable.NU12,
        "NU13" to Res.drawable.NU13,
        "NU14" to Res.drawable.NU14,
        "NU15" to Res.drawable.NU15,
        "NU16" to Res.drawable.NU16,
        "NU17" to Res.drawable.NU17,
        "NU18" to Res.drawable.NU18,
        "NU18a" to Res.drawable.NU18a,
        "NU19" to Res.drawable.NU19,
        "NU20" to Res.drawable.NU20,
        "NU21" to Res.drawable.NU21,
        "NU22" to Res.drawable.NU22,
        "NU22a" to Res.drawable.NU22a,
        "O1" to Res.drawable.O1,
        "O1A" to Res.drawable.O1A,
        "O2" to Res.drawable.O2,
        "O3" to Res.drawable.O3,
        "O4" to Res.drawable.O4,
        "O5" to Res.drawable.O5,
        "O5A" to Res.drawable.O5A,
        "O6" to Res.drawable.O6,
        "O6A" to Res.drawable.O6A,
        "O6B" to Res.drawable.O6B,
        "O6C" to Res.drawable.O6C,
        "O6D" to Res.drawable.O6D,
        "O6E" to Res.drawable.O6E,
        "O6F" to Res.drawable.O6F,
        "O7" to Res.drawable.O7,
        "O8" to Res.drawable.O8,
        "O9" to Res.drawable.O9,
        "O10" to Res.drawable.O10,
        "O10A" to Res.drawable.O10A,
        "O10B" to Res.drawable.O10B,
        "O10C" to Res.drawable.O10C,
        "O11" to Res.drawable.O11,
        "O12" to Res.drawable.O12,
        "O13" to Res.drawable.O13,
        "O14" to Res.drawable.O14,
        "O15" to Res.drawable.O15,
        "O16" to Res.drawable.O16,
        "O17" to Res.drawable.O17,
        "O18" to Res.drawable.O18,
        "O19" to Res.drawable.O19,
        "O19A" to Res.drawable.O19A,
        "O20" to Res.drawable.O20,
        "O20A" to Res.drawable.O20A,
        "O21" to Res.drawable.O21,
        "O22" to Res.drawable.O22,
        "O23" to Res.drawable.O23,
        "O24" to Res.drawable.O24,
        "O24A" to Res.drawable.O24A,
        "O25" to Res.drawable.O25,
        "O25A" to Res.drawable.O25A,
        "O26" to Res.drawable.O26,
        "O27" to Res.drawable.O27,
        "O28" to Res.drawable.O28,
        "O29" to Res.drawable.O29,
        "O29A" to Res.drawable.O29A,
        "O30" to Res.drawable.O30,
        "O30A" to Res.drawable.O30A,
        "O31" to Res.drawable.O31,
        "O32" to Res.drawable.O32,
        "O33" to Res.drawable.O33,
        "O33A" to Res.drawable.O33A,
        "O34" to Res.drawable.O34,
        "O35" to Res.drawable.O35,
        "O36" to Res.drawable.O36,
        "O36A" to Res.drawable.O36A,
        "O36B" to Res.drawable.O36B,
        "O36C" to Res.drawable.O36C,
        "O36D" to Res.drawable.O36D,
        "O37" to Res.drawable.O37,
        "O38" to Res.drawable.O38,
        "O39" to Res.drawable.O39,
        "O40" to Res.drawable.O40,
        "O41" to Res.drawable.O41,
        "O42" to Res.drawable.O42,
        "O43" to Res.drawable.O43,
        "O44" to Res.drawable.O44,
        "O45" to Res.drawable.O45,
        "O46" to Res.drawable.O46,
        "O47" to Res.drawable.O47,
        "O48" to Res.drawable.O48,
        "O49" to Res.drawable.O49,
        "O50" to Res.drawable.O50,
        "O50A" to Res.drawable.O50A,
        "O50B" to Res.drawable.O50B,
        "O51" to Res.drawable.O51,
        "P1" to Res.drawable.P1,
        "P1A" to Res.drawable.P1A,
        "P2" to Res.drawable.P2,
        "P3" to Res.drawable.P3,
        "P3A" to Res.drawable.P3A,
        "P4" to Res.drawable.P4,
        "P5" to Res.drawable.P5,
        "P6" to Res.drawable.P6,
        "P7" to Res.drawable.P7,
        "P8" to Res.drawable.P8,
        "P9" to Res.drawable.P9,
        "P10" to Res.drawable.P10,
        "P11" to Res.drawable.P11,
        "Q1" to Res.drawable.Q1,
        "Q2" to Res.drawable.Q2,
        "Q3" to Res.drawable.Q3,
        "Q4" to Res.drawable.Q4,
        "Q5" to Res.drawable.Q5,
        "Q6" to Res.drawable.Q6,
        "Q7" to Res.drawable.Q7,
        "R1" to Res.drawable.R1,
        "R2" to Res.drawable.R2,
        "R2A" to Res.drawable.R2A,
        "R3" to Res.drawable.R3,
        "R3A" to Res.drawable.R3A,
        "R3B" to Res.drawable.R3B,
        "R4" to Res.drawable.R4,
        "R5" to Res.drawable.R5,
        "R6" to Res.drawable.R6,
        "R7" to Res.drawable.R7,
        "R8" to Res.drawable.R8,
        "R9" to Res.drawable.R9,
        "R10" to Res.drawable.R10,
        "R10A" to Res.drawable.R10A,
        "R11" to Res.drawable.R11,
        "R12" to Res.drawable.R12,
        "R13" to Res.drawable.R13,
        "R14" to Res.drawable.R14,
        "R15" to Res.drawable.R15,
        "R16" to Res.drawable.R16,
        "R16A" to Res.drawable.R16A,
        "R17" to Res.drawable.R17,
        "R18" to Res.drawable.R18,
        "R19" to Res.drawable.R19,
        "R20" to Res.drawable.R20,
        "R21" to Res.drawable.R21,
        "R22" to Res.drawable.R22,
        "R23" to Res.drawable.R23,
        "R24" to Res.drawable.R24,
        "R25" to Res.drawable.R25,
        "R26" to Res.drawable.R26,
        "R27" to Res.drawable.R27,
        "R28" to Res.drawable.R28,
        "R29" to Res.drawable.R29,
        "S1" to Res.drawable.S1,
        "S2" to Res.drawable.S2,
        "S2A" to Res.drawable.S2A,
        "S3" to Res.drawable.S3,
        "S4" to Res.drawable.S4,
        "S5" to Res.drawable.S5,
        "S6" to Res.drawable.S6,
        "S6A" to Res.drawable.S6A,
        "S7" to Res.drawable.S7,
        "S8" to Res.drawable.S8,
        "S9" to Res.drawable.S9,
        "S10" to Res.drawable.S10,
        "S11" to Res.drawable.S11,
        "S12" to Res.drawable.S12,
        "S13" to Res.drawable.S13,
        "S14" to Res.drawable.S14,
        "S14A" to Res.drawable.S14A,
        "S14B" to Res.drawable.S14B,
        "S15" to Res.drawable.S15,
        "S16" to Res.drawable.S16,
        "S17" to Res.drawable.S17,
        "S17A" to Res.drawable.S17A,
        "S18" to Res.drawable.S18,
        "S19" to Res.drawable.S19,
        "S20" to Res.drawable.S20,
        "S21" to Res.drawable.S21,
        "S22" to Res.drawable.S22,
        "S23" to Res.drawable.S23,
        "S24" to Res.drawable.S24,
        "S25" to Res.drawable.S25,
        "S26" to Res.drawable.S26,
        "S26A" to Res.drawable.S26A,
        "S26B" to Res.drawable.S26B,
        "S27" to Res.drawable.S27,
        "S28" to Res.drawable.S28,
        "S29" to Res.drawable.S29,
        "S30" to Res.drawable.S30,
        "S31" to Res.drawable.S31,
        "S32" to Res.drawable.S32,
        "S33" to Res.drawable.S33,
        "S34" to Res.drawable.S34,
        "S35" to Res.drawable.S35,
        "S35A" to Res.drawable.S35A,
        "S36" to Res.drawable.S36,
        "S37" to Res.drawable.S37,
        "S38" to Res.drawable.S38,
        "S39" to Res.drawable.S39,
        "S40" to Res.drawable.S40,
        "S41" to Res.drawable.S41,
        "S42" to Res.drawable.S42,
        "S43" to Res.drawable.S43,
        "S44" to Res.drawable.S44,
        "S45" to Res.drawable.S45,
        "S46" to Res.drawable.S46,
        "T1" to Res.drawable.T1,
        "T2" to Res.drawable.T2,
        "T3" to Res.drawable.T3,
        "T3A" to Res.drawable.T3A,
        "T4" to Res.drawable.T4,
        "T5" to Res.drawable.T5,
        "T6" to Res.drawable.T6,
        "T7" to Res.drawable.T7,
        "T7A" to Res.drawable.T7A,
        "T8" to Res.drawable.T8,
        "T8A" to Res.drawable.T8A,
        "T9" to Res.drawable.T9,
        "T9A" to Res.drawable.T9A,
        "T10" to Res.drawable.T10,
        "T11" to Res.drawable.T11,
        "T11A" to Res.drawable.T11A,
        "T12" to Res.drawable.T12,
        "T13" to Res.drawable.T13,
        "T14" to Res.drawable.T14,
        "T15" to Res.drawable.T15,
        "T16" to Res.drawable.T16,
        "T16A" to Res.drawable.T16A,
        "T17" to Res.drawable.T17,
        "T18" to Res.drawable.T18,
        "T19" to Res.drawable.T19,
        "T20" to Res.drawable.T20,
        "T21" to Res.drawable.T21,
        "T22" to Res.drawable.T22,
        "T23" to Res.drawable.T23,
        "T24" to Res.drawable.T24,
        "T25" to Res.drawable.T25,
        "T26" to Res.drawable.T26,
        "T27" to Res.drawable.T27,
        "T28" to Res.drawable.T28,
        "T29" to Res.drawable.T29,
        "T30" to Res.drawable.T30,
        "T31" to Res.drawable.T31,
        "T32" to Res.drawable.T32,
        "T32A" to Res.drawable.T32A,
        "T33" to Res.drawable.T33,
        "T33A" to Res.drawable.T33A,
        "T34" to Res.drawable.T34,
        "T35" to Res.drawable.T35,
        "T36" to Res.drawable.T36,
        "U1" to Res.drawable.U1,
        "U2" to Res.drawable.U2,
        "U3" to Res.drawable.U3,
        "U4" to Res.drawable.U4,
        "U5" to Res.drawable.U5,
        "U6" to Res.drawable.U6,
        "U6A" to Res.drawable.U6A,
        "U6B" to Res.drawable.U6B,
        "U7" to Res.drawable.U7,
        "U8" to Res.drawable.U8,
        "U9" to Res.drawable.U9,
        "U10" to Res.drawable.U10,
        "U11" to Res.drawable.U11,
        "U12" to Res.drawable.U12,
        "U13" to Res.drawable.U13,
        "U14" to Res.drawable.U14,
        "U15" to Res.drawable.U15,
        "U16" to Res.drawable.U16,
        "U17" to Res.drawable.U17,
        "U18" to Res.drawable.U18,
        "U19" to Res.drawable.U19,
        "U20" to Res.drawable.U20,
        "U21" to Res.drawable.U21,
        "U22" to Res.drawable.U22,
        "U23" to Res.drawable.U23,
        "U23A" to Res.drawable.U23A,
        "U24" to Res.drawable.U24,
        "U25" to Res.drawable.U25,
        "U26" to Res.drawable.U26,
        "U27" to Res.drawable.U27,
        "U28" to Res.drawable.U28,
        "U29" to Res.drawable.U29,
        "U29A" to Res.drawable.U29A,
        "U30" to Res.drawable.U30,
        "U31" to Res.drawable.U31,
        "U32" to Res.drawable.U32,
        "U32A" to Res.drawable.U32A,
        "U33" to Res.drawable.U33,
        "U34" to Res.drawable.U34,
        "U35" to Res.drawable.U35,
        "U36" to Res.drawable.U36,
        "U37" to Res.drawable.U37,
        "U38" to Res.drawable.U38,
        "U39" to Res.drawable.U39,
        "U40" to Res.drawable.U40,
        "U41" to Res.drawable.U41,
        "U42" to Res.drawable.U42,
        "V1" to Res.drawable.V1,
        "V1A" to Res.drawable.V1A,
        "V1B" to Res.drawable.V1B,
        "V1C" to Res.drawable.V1C,
        "V1D" to Res.drawable.V1D,
        "V1E" to Res.drawable.V1E,
        "V1F" to Res.drawable.V1F,
        "V1G" to Res.drawable.V1G,
        "V1H" to Res.drawable.V1H,
        "V1I" to Res.drawable.V1I,
        "V2" to Res.drawable.V2,
        "V2A" to Res.drawable.V2A,
        "V3" to Res.drawable.V3,
        "V4" to Res.drawable.V4,
        "V5" to Res.drawable.V5,
        "V6" to Res.drawable.V6,
        "V7" to Res.drawable.V7,
        "V7A" to Res.drawable.V7A,
        "V7B" to Res.drawable.V7B,
        "V8" to Res.drawable.V8,
        "V9" to Res.drawable.V9,
        "V10" to Res.drawable.V10,
        "V11" to Res.drawable.V11,
        "V11A" to Res.drawable.V11A,
        "V11B" to Res.drawable.V11B,
        "V11C" to Res.drawable.V11C,
        "V12" to Res.drawable.V12,
        "V12A" to Res.drawable.V12A,
        "V12B" to Res.drawable.V12B,
        "V13" to Res.drawable.V13,
        "V14" to Res.drawable.V14,
        "V15" to Res.drawable.V15,
        "V16" to Res.drawable.V16,
        "V17" to Res.drawable.V17,
        "V18" to Res.drawable.V18,
        "V19" to Res.drawable.V19,
        "V20" to Res.drawable.V20,
        "V20A" to Res.drawable.V20A,
        "V20B" to Res.drawable.V20B,
        "V20C" to Res.drawable.V20C,
        "V20D" to Res.drawable.V20D,
        "V20E" to Res.drawable.V20E,
        "V20F" to Res.drawable.V20F,
        "V20G" to Res.drawable.V20G,
        "V20H" to Res.drawable.V20H,
        "V20I" to Res.drawable.V20I,
        "V20J" to Res.drawable.V20J,
        "V20K" to Res.drawable.V20K,
        "V20L" to Res.drawable.V20L,
        "V21" to Res.drawable.V21,
        "V22" to Res.drawable.V22,
        "V23" to Res.drawable.V23,
        "V23A" to Res.drawable.V23A,
        "V24" to Res.drawable.V24,
        "V25" to Res.drawable.V25,
        "V26" to Res.drawable.V26,
        "V27" to Res.drawable.V27,
        "V28" to Res.drawable.V28,
        "V28A" to Res.drawable.V28A,
        "V29" to Res.drawable.V29,
        "V29A" to Res.drawable.V29A,
        "V30" to Res.drawable.V30,
        "V30A" to Res.drawable.V30A,
        "V31" to Res.drawable.V31,
        "V31A" to Res.drawable.V31A,
        "V32" to Res.drawable.V32,
        "V33" to Res.drawable.V33,
        "V33A" to Res.drawable.V33A,
        "V34" to Res.drawable.V34,
        "V35" to Res.drawable.V35,
        "V36" to Res.drawable.V36,
        "V37" to Res.drawable.V37,
        "V37A" to Res.drawable.V37A,
        "V38" to Res.drawable.V38,
        "V39" to Res.drawable.V39,
        "V40" to Res.drawable.V40,
        "V40A" to Res.drawable.V40A,
        "W1" to Res.drawable.W1,
        "W2" to Res.drawable.W2,
        "W3" to Res.drawable.W3,
        "W3A" to Res.drawable.W3A,
        "W4" to Res.drawable.W4,
        "W5" to Res.drawable.W5,
        "W6" to Res.drawable.W6,
        "W7" to Res.drawable.W7,
        "W8" to Res.drawable.W8,
        "W9" to Res.drawable.W9,
        "W9A" to Res.drawable.W9A,
        "X1D46" to Res.drawable.X1D46,
        "W10" to Res.drawable.W10,
        "W10A" to Res.drawable.W10A,
        "W11" to Res.drawable.W11,
        "W12" to Res.drawable.W12,
        "W13" to Res.drawable.W13,
        "W14" to Res.drawable.W14,
        "W14A" to Res.drawable.W14A,
        "W15" to Res.drawable.W15,
        "W16" to Res.drawable.W16,
        "W17" to Res.drawable.W17,
        "W17A" to Res.drawable.W17A,
        "W18" to Res.drawable.W18,
        "W18A" to Res.drawable.W18A,
        "W19" to Res.drawable.W19,
        "W20" to Res.drawable.W20,
        "W21" to Res.drawable.W21,
        "W22" to Res.drawable.W22,
        "W23" to Res.drawable.W23,
        "W24" to Res.drawable.W24,
        "W24A" to Res.drawable.W24A,
        "W25" to Res.drawable.W25,
        "X1" to Res.drawable.X1,
        "I10X1" to Res.drawable.I10X1,
        "X2" to Res.drawable.X2,
        "X3" to Res.drawable.X3,
        "X4" to Res.drawable.X4,
        "X4A" to Res.drawable.X4A,
        "X4B" to Res.drawable.X4B,
        "X5" to Res.drawable.X5,
        "X6" to Res.drawable.X6,
        "X6A" to Res.drawable.X6A,
        "X7" to Res.drawable.X7,
        "X8" to Res.drawable.X8,
        "X8A" to Res.drawable.X8A,
        "Y1" to Res.drawable.Y1,
        "Y1A" to Res.drawable.Y1A,
        "Y2" to Res.drawable.Y2,
        "Y3" to Res.drawable.Y3,
        "Y4" to Res.drawable.Y4,
        "Y5" to Res.drawable.Y5,
        "Y6" to Res.drawable.Y6,
        "Y7" to Res.drawable.Y7,
        "Y8" to Res.drawable.Y8,
        "Z1" to Res.drawable.Z1,
        "Z2" to Res.drawable.Z2,
        "Z2A" to Res.drawable.Z2A,
        "Z2B" to Res.drawable.Z2B,
        "Z2C" to Res.drawable.Z2C,
        "Z2D" to Res.drawable.Z2D,
        "Z3" to Res.drawable.Z3,
        "Z3A" to Res.drawable.Z3A,
        "Z3B" to Res.drawable.Z3B,
        "Z4" to Res.drawable.Z4,
        "Z4A" to Res.drawable.Z4A,
        "Z5" to Res.drawable.Z5,
        "Z5A" to Res.drawable.Z5A,
        "Z6" to Res.drawable.Z6,
        "Z7" to Res.drawable.Z7,
        "Z8" to Res.drawable.Z8,
        "Z9" to Res.drawable.Z9,
        "Z10" to Res.drawable.Z10,
        "Z11" to Res.drawable.Z11,
        "Z12" to Res.drawable.Z12,
        "Z13" to Res.drawable.Z13,
        "Z14" to Res.drawable.Z14,
        "Z15" to Res.drawable.Z15,
        "Z15A" to Res.drawable.Z15A,
        "Z15B" to Res.drawable.Z15B,
        "Z15C" to Res.drawable.Z15C,
        "Z15D" to Res.drawable.Z15D,
        "Z15E" to Res.drawable.Z15E,
        "Z15F" to Res.drawable.Z15F,
        "Z15G" to Res.drawable.Z15G,
        "Z15H" to Res.drawable.Z15H,
        "Z15I" to Res.drawable.Z15I,
        "Z16" to Res.drawable.Z16,
        "Z16A" to Res.drawable.Z16A,
        "Z16B" to Res.drawable.Z16B,
        "Z16C" to Res.drawable.Z16C,
        "Z16D" to Res.drawable.Z16D,
        "Z16E" to Res.drawable.Z16E,
        "Z16F" to Res.drawable.Z16F,
        "Z16G" to Res.drawable.Z16G,
        "Z16H" to Res.drawable.Z16H,
        "Aa1" to Res.drawable.Aa1,
        "Aa2" to Res.drawable.Aa2,
        "Aa3" to Res.drawable.Aa3,
        "Aa4" to Res.drawable.Aa4,
        "Aa5" to Res.drawable.Aa5,
        "Aa6" to Res.drawable.Aa6,
        "Aa7" to Res.drawable.Aa7,
        "Aa7A" to Res.drawable.Aa7A,
        "Aa7B" to Res.drawable.Aa7B,
        "Aa8" to Res.drawable.Aa8,
        "Aa9" to Res.drawable.Aa9,
        "Aa10" to Res.drawable.Aa10,
        "Aa11" to Res.drawable.Aa11,
        "Aa12" to Res.drawable.Aa12,
        "Aa13" to Res.drawable.Aa13,
        "Aa14" to Res.drawable.Aa14,
        "Aa15" to Res.drawable.Aa15,
        "Aa16" to Res.drawable.Aa16,
        "Aa17" to Res.drawable.Aa17,
        "Aa18" to Res.drawable.Aa18,
        "Aa19" to Res.drawable.Aa19,
        "Aa20" to Res.drawable.Aa20,
        "Aa21" to Res.drawable.Aa21,
        "Aa22" to Res.drawable.Aa22,
        "Aa23" to Res.drawable.Aa23,
        "Aa24" to Res.drawable.Aa24,
        "Aa25" to Res.drawable.Aa25,
        "Aa26" to Res.drawable.Aa26,
        "Aa27" to Res.drawable.Aa27,
        "Aa28" to Res.drawable.Aa28,
        "Aa29" to Res.drawable.Aa29,
        "Aa30" to Res.drawable.Aa30,
        "Aa31" to Res.drawable.Aa31,
        "Aa32" to Res.drawable.Aa32
    )

}
